import axios from 'lib/utils/axios';
import logrocket from '@/services/logrocket';

import { fetchByType } from 'services/widget';
import sendTestEvent from 'api/requests/streamer/widgets/sendTestEvent';

async function fetchWidgetsByType({ getters, commit }, type) {
  const { getCurrentPage } = getters;

  try {
    const data = await fetchByType(getCurrentPage, type);

    commit('SET_DATA', data);
  } catch (error) {
    logrocket.logger(error);

    throw new Error;
  }
}

// eslint-disable-next-line no-unused-vars
async function initiateTestEvent({ state }, widgetId) {
  try {
    await sendTestEvent(axios, widgetId);
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

export default {
  fetchWidgetsByType,
  initiateTestEvent,
};
